// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGSmallWarningIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}
// @FIXME
const style = {
  flex: "0 0 auto",
  cursor: "pointer",
  paddingRight: "5px",
  verticalAlign: "middle",
};

export default class SVGSmallWarningIcon extends PureComponent<
  ISVGSmallWarningIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 25}
        style={style}
        viewBox="0 0 25 25"
        width="25"
        height="25"
      >
        <rect
          fill="#ffffff"
          stroke="#ffffff"
          strokeWidth="2"
          stroke-linejoin="round"
          stroke-dashoffset=""
          fillRule="nonzero"
          id="svg_2"
          x="12.476190571907228"
          y="9.000000221388675"
          width="0.09523788598869803"
          height="9.285713808877134"
          // style="color: rgb(0, 0, 0);"
          // class=""
          fill-opacity="1"
          stroke-opacity="1"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          //fill="#ED1F24"
          fill="#ED1F24"
          d="M24.392,19.67c-0.224-0.733-0.737-1.331-1.112-1.926
	c-0.198-0.315-0.314-0.625-0.513-0.941c-2.421-3.841-4.811-7.753-7.232-11.595c-0.38-0.603-0.743-1.209-1.112-1.797
	c-0.508-0.808-0.786-1.702-2.011-1.797c-0.273,0.173-0.612,0.165-0.856,0.342c-0.489,0.354-0.744,1.062-1.07,1.583
	C9.845,4.569,9.22,5.619,8.562,6.663c-1.917,3.04-3.775,6.133-5.691,9.199c-0.682,1.093-1.51,2.183-2.096,3.337
	c-0.17,0.336-0.353,1.134-0.171,1.626c0.558,1.513,3.211,1.156,5.263,1.155c4.207,0,8.415,0,12.622,0c1.545,0,4.25,0.256,5.22-0.342
	C24.19,21.34,24.666,20.561,24.392,19.67z M12.883,19.071c-0.101,0.082-0.235,0.088-0.428,0.085
	c-0.694-0.011-0.907-0.556-0.856-1.198c0.13-0.138,0.184-0.363,0.343-0.471c0.12-0.082,0.276-0.085,0.385-0.17
	C13.491,17.283,13.818,18.801,12.883,19.071z M13.396,14.792c-0.069,0.215-0.229,0.346-0.342,0.513
	c-0.481,0.129-1.021,0.238-1.326-0.214c-0.26-0.386-0.171-1.213-0.171-1.84c0-1.013,0-2.025,0-3.038c0-0.475-0.08-1.095,0.042-1.498
	c0.066-0.215,0.23-0.348,0.343-0.513c0.156-0.058,0.313-0.114,0.471-0.171c0.353,0.024,0.703,0.159,0.855,0.385
	c0.26,0.386,0.171,1.215,0.171,1.839c0,1.027,0,2.054,0,3.081C13.439,13.793,13.52,14.413,13.396,14.792z"
        />
      </svg>
    );
  }
}
